export const ADVANTAGE_WORDS = ['advantage', 'disadvantage'];
export const ADVANTAGE_LIMITS = { sources: 16, name: 80, extraDice: 3 };
/** The name of the source a form's own control adds: a reason the table cannot see. */
export const CHOSEN_SOURCE = 'chosen';
export const NOT_ADVANTAGE_DICE = "This game system's dice do not take advantage or disadvantage here.";
export const ONLY_THE_DM_SETS_ASIDE = 'Only the DM may set the reasons for it aside.';
export const isAdvantageWord = (v) => v === 'advantage' || v === 'disadvantage';
export const isAdvantageAsk = (v) => isAdvantageWord(v) || v === 'normal';
/** The sources the table knows, and the form's word: null when nothing bears on the throw. */
export function decideAdvantage(table, ask) {
    const sources = [...table.slice(0, ADVANTAGE_LIMITS.sources - 1), ...(isAdvantageWord(ask) ? [{ with: ask, name: CHOSEN_SOURCE }] : [])];
    if (!sources.length)
        return null;
    if (ask === 'normal')
        return { sources, result: null, setAside: true };
    const up = sources.some((s) => s.with === 'advantage');
    const down = sources.some((s) => s.with === 'disadvantage');
    return { sources, result: up === down ? null : up ? 'advantage' : 'disadvantage' };
}
/** The dice one throw is made with: the system's plain dice, or with `dice` more, keeping the highest or lowest. */
export function advantageDice(d, result) {
    const { advantage, ...plain } = d;
    if (!result || !advantage)
        return plain;
    return { count: d.count + advantage.dice, sides: d.sides, keep: { which: result === 'advantage' ? 'highest' : 'lowest', n: d.count } };
}
const word = (w) => (w === 'advantage' ? 'Advantage' : 'Disadvantage');
/** "Disadvantage (Poisoned); Advantage (Help) → neither"; one side alone needs no arrow. `forPlayer`: a source about the target is only `situation`. */
export function advantageText(f, forPlayer = false) {
    const said = ['disadvantage', 'advantage'].flatMap((w) => {
        const names = [...new Set(f.sources.filter((s) => s.with === w).map((s) => (forPlayer && s.aboutTarget ? 'situation' : s.name)))];
        return names.length ? [`${word(w)} (${names.join(', ')})`] : [];
    });
    if (f.setAside)
        return `${said.join('; ')} → neither, by the DM`;
    return said.length > 1 ? `${said.join('; ')} → neither` : said.join('');
}
/** Stored facts: exact shape or null. */
export function parseAdvantageFacts(v) {
    if (typeof v !== 'object' || v === null || Array.isArray(v))
        return null;
    const f = v;
    if (!Array.isArray(f.sources) || f.sources.length < 1 || f.sources.length > ADVANTAGE_LIMITS.sources)
        return null;
    const sources = [];
    for (const s of f.sources) {
        if (typeof s !== 'object' || s === null || !isAdvantageWord(s.with) || typeof s.name !== 'string' || s.name.length < 1 || s.name.length > ADVANTAGE_LIMITS.name || (s.aboutTarget !== undefined && s.aboutTarget !== true))
            return null;
        sources.push({ with: s.with, name: s.name, ...(s.aboutTarget ? { aboutTarget: true } : {}) });
    }
    if (f.result !== null && !isAdvantageWord(f.result))
        return null;
    if (f.setAside !== undefined && f.setAside !== true)
        return null;
    return { sources, result: f.result, ...(f.setAside ? { setAside: true } : {}) };
}
//# sourceMappingURL=advantage.js.map